import Vue from "vue";

import FeaturedWinners from "./FeaturedWinners.vue";

export function load() {
    const selector = "featured-winners";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(FeaturedWinners, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
